
import React from 'react';

const ActivityOverlayView = (props) => {
  
    return (
      <div className="overlayView">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    )
  
}

export default ActivityOverlayView